module.exports = __webpack_public_path__ + "media/country_flags/gm-fc99b6d9.png";